import { create } from "zustand";
import { getMe, login as apiLogin, logout as apiLogout, register as apiRegister, type User } from "./api";

interface AuthStore {
  user: User | null;
  loading: boolean;
  initialized: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, name?: string) => Promise<void>;
  logout: () => Promise<void>;
  checkAuth: () => Promise<void>;
}

export const useAuth = create<AuthStore>((set) => ({
  user: null,
  loading: false,
  initialized: false,

  login: async (email: string, password: string) => {
    set({ loading: true });
    try {
      const { user } = await apiLogin(email, password);
      set({ user, loading: false });
    } catch (error) {
      set({ loading: false });
      throw error;
    }
  },

  register: async (email: string, password: string, name?: string) => {
    set({ loading: true });
    try {
      const { user } = await apiRegister(email, password, name);
      set({ user, loading: false });
    } catch (error) {
      set({ loading: false });
      throw error;
    }
  },

  logout: async () => {
    await apiLogout();
    set({ user: null });
  },

  checkAuth: async () => {
    try {
      const { user } = await getMe();
      set({ user, initialized: true });
    } catch {
      set({ user: null, initialized: true });
    }
  },
}));
